export default "__VITE_ASSET__CvSI3tYT__"